import paymentMandateData, { PaymentMandateData } from './paymentMandateData';

export interface PaymentMandateHistoryEntry {
  paymentMandate: PaymentMandateData;
  executingApplicationUserFullName: string;
  dateTime: string;
}

function parse(
  data?: Partial<PaymentMandateHistoryEntry>
): PaymentMandateHistoryEntry {
  return {
    paymentMandate: paymentMandateData.parse(data?.paymentMandate),
    executingApplicationUserFullName:
      data?.executingApplicationUserFullName || '',
    dateTime: data?.dateTime ? data.dateTime : new Date().toISOString(),
  };
}

export default { parse };
